import { migrateToV1 } from "./V1Migrator";

const migrateToV2 = (currentData, data) => {
    currentData = currentData.version === 1
        ? currentData
        : migrateToV1(currentData, data);
    let newData = {
        name: currentData.name ? currentData.name : data.name,
        elements: currentData.elements?.length ? currentData.elements : data.elements,
        settings: Object.keys(currentData.settings || {}).length ? currentData.settings : data.settings,
        view: Object.keys(currentData.view || {}).length ? currentData.view : data.view,
        species: Object.keys(currentData.species || {}).length ? currentData.species : data.species,
        image: currentData.image || data.image,
        showMigrationMessage: true,
    }
    newData.elements = migrateElementsToV2(newData.elements, newData.species);
    return newData;
};

const migrateElementsToV2 = (elements = [], species = {}) => {
    return elements.map((element) => {
        // Migrate species labels from a simple array of strings to an array of objects
        // e.g. ['Bed 1', 'Carrot'] => [{ type: 'custom', value: 'Bed 1' }, { type: 'species', id: 1, keys: ['name'] }]
        element.data.labels = element.data.labels.filter(l => l).reduce((labels, label) => {
            let [speciesId, key] = element.speciesIds.reduce((acc, speciesId) => {
                return ['name', 'scientific_name', 'parent_name'].reduce((acc2, key) => {
                    return species[speciesId][key] == label
                        ? [speciesId, key]
                        : acc2;
                }, acc);
            }, [null, null]);
            if (speciesId) {
                let speciesLabel = labels.find(l => l.type == 'species' && l.id == speciesId);
                if (speciesLabel) {
                    speciesLabel.keys.push(key);
                } else {
                    labels.push({ type: 'species', id: speciesId, keys: [key] });
                }
            } else {
                labels.push({ type: 'custom', value: label, visible: true });
            }
            return labels;
        }, []);
        element.speciesIds.map((speciesId) => {
            let speciesLabel = element.data.labels.find(l => l.type == 'species' && l.id == speciesId);
            if (!speciesLabel) {
                element.data.labels.push({ type: 'species', id: speciesId, keys: [] });
            }
        });
        if (element.data.name) {
            element.data.labels.unshift({ type: 'custom', value: element.data.name, visible: false });
        }
        delete element.data.name;
        return element;
    });

}

export { migrateToV2 };
